// Platform staff (InmoTera's own team). Stored role values; "platform_admin" is shown as "Admin".
// The API enforces what each role may do (backend/platform_perms.py); the console reads the list from /admin/me and
// hides the controls a role can't use.
import { createContext, useContext } from "react";
import { t } from "@/i18n";

export const STAFF_ROLES = ["superadmin", "platform_admin"];
export const isStaff = (user) => STAFF_ROLES.includes(user?.role);

export const PermsCtx = createContext({ role: null, permissions: [] });
export function useCan() {
  const p = useContext(PermsCtx);
  return (perm) => p.permissions.includes(perm);
}

export const staffRoleLabel = (role) => (role === "superadmin" ? t("Super admin") : role === "platform_admin" ? t("Admin") : role || "");
